import * as getUsersByCurrentShipper from "./getUsersByCurrentShipper";

export const mappers = { ...getUsersByCurrentShipper };
